import { Autocomplete, TextField } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { Form } from 'react-bootstrap'

import { api_gateway } from '../../conexoes/api'
import { exclamacao, lixeiraVermelho } from '../../utils/alternanciaIcones'

import * as S from './styles'

function parseOptionsObject(dados, tipo) {
  switch (tipo) {
    case 'operadora':
      dados = dados
        .filter((item) => item.ds_apelido)
        .map((item) => {
          return { id: item.cd_dsp_operadora, label: item.ds_apelido }
        })
      break

    case 'plano':
      dados = dados
        .filter((item) => item.ds_dsp_plano)
        .map((item) => {
          return {
            id: item.cd_dsp_plano,
            label: item.ds_dsp_plano,
            cd_dsp_operadora: item.cd_dsp_operadora
          }
        })
      break
  }
  return dados
}

export function RenderInputRows({
  itens,
  itensArray,
  setItensArray,
  setMensagemErro,
  setRevelarMensagemErro,
  mostrarBotaoNovoLote,
  condicao,
  isReposicao
}) {
  const localTema = localStorage.getItem('tema')
  const temaEscuro = localTema === 'escuro'
  const [tipoSIMcardOptions, setTipoSIMcardOptions] = useState([])
  const [operadoraOptions, setOperadoraOptions] = useState([])
  const [planosPorIndex, setPlanosPorIndex] = useState({})
  const [loading, setLoading] = useState(false)
  const [planosFixos, setPlanosFixos] = useState([])

  const scrollRef = useRef(null)

  async function getPlanos(cd_dsp_operadora) {
    setLoading(true)
    if (!cd_dsp_operadora) return []
    let planoOptions = []

    const { data } = await api_gateway.get(
      `/api/v2/devices/fetchCustomerPlans?carrier=${cd_dsp_operadora}`
    )

    if (!data) return []

    setLoading(false)
    planoOptions = parseOptionsObject(data, 'plano')
    return planoOptions
  }

  useEffect(() => {
    async function fetchModalData() {
      setLoading(true)

      const temIgnorar = !!condicao?.ignorar

      const queryIgnorar = temIgnorar
        ? `?ignorar=${encodeURIComponent(JSON.stringify(condicao.ignorar))}`
        : ''

      const rota = '/m1/consultar/operadora' + queryIgnorar

      const operadoraData = await api_gateway.get(rota)

      if (operadoraData.data.dados.length) {
        setOperadoraOptions(
          parseOptionsObject(operadoraData.data.dados, 'operadora')
        )
      }

      if (!isReposicao) {
        try {
          const { data } = await api_gateway.get('/m1/consultar/planos')
          if (data?.dados?.length) {
            const planos = parseOptionsObject(data.dados, 'plano')
            setPlanosFixos(planos)
          }
        } catch (error) {
          console.error(error)
        }
      }

      const tipoSIMcardData = await api_gateway.get(
        '/m1/consultar/simcard_tipo_operadora'
      )
      if (tipoSIMcardData.data.dados.length) {
        setTipoSIMcardOptions(extrairItensUnicos(tipoSIMcardData.data.dados))
      }

      setLoading(false)
    }

    fetchModalData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function extrairItensUnicos(array) {
    let arrayTipos = [
      ...new Set(['Normal', ...array.map((item) => item.ds_simcard_tipo)])
    ]
    return arrayTipos
  }

  async function handleOperadoraInput(value, index) {
    setPlanosPorIndex((prev) => ({ ...prev, [index]: [] }))

    let newArray = [...itensArray]
    newArray[index].cd_dsp_operadora = value.id
    newArray[index].OPERADORA = value.label
    newArray[index].cd_dsp_plano = ''
    newArray[index].PLANO = ''
    setItensArray(newArray)

    if (!value.id) return

    if (isReposicao) {
      try {
        const planos = await getPlanos(value.id)
        setPlanosPorIndex((prev) => ({ ...prev, [index]: planos }))
      } catch (e) {
        console.error('Erro ao carregar planos:', e)
        setPlanosPorIndex((prev) => ({ ...prev, [index]: [] }))
      }
    } else {
      const planosFiltrados = planosFixos.filter(
        (plano) => plano.cd_dsp_operadora === value.id
      )

      setPlanosPorIndex((prev) => ({
        ...prev,
        [index]: planosFiltrados
      }))
    }
  }

  function handlePlanoInput(value, index) {
    let newArray = [...itensArray]
    newArray[index].cd_dsp_plano = value.id
    newArray[index].PLANO = value.label
    setItensArray(newArray)
  }

  function handleTipoSimcardInput(value, item, index) {
    let newArray = [...itensArray]
    newArray[index].TAMANHO = value
    setItensArray(newArray)
  }

  function handleQuantidadeSimcards(value, item, index) {
    let newArray = [...itensArray]
    newArray[index].NUMERO_SIMCARDS = value
    setItensArray(newArray)
  }

  function deleteInputRow(item, index) {
    let newArray = [...itensArray]
    newArray = newArray.filter((lote, i) => i !== index)
    setItensArray([...newArray])
  }

  function updateItensArray() {
    const ultimoLote = itensArray[itensArray.length - 1]
    const newCdPedido = ultimoLote.cd_pedido + 1

    if (
      !ultimoLote.OPERADORA ||
      !ultimoLote.PLANO ||
      !ultimoLote.TAMANHO ||
      !ultimoLote.NUMERO_SIMCARDS
    ) {
      setMensagemErro('Preencha os detalhes do lote anterior')
      setRevelarMensagemErro(true)
      return
    } else if (ultimoLote.NUMERO_SIMCARDS <= 0) {
      setMensagemErro('A quantidade de SIM cards deve ser maior que 0')
      setRevelarMensagemErro(true)
      return
    }

    const newItem = {
      cd_pedido: newCdPedido,
      OPERADORA: '',
      cd_dsp_operadora: '',
      PLANO: '',
      cd_dsp_plano: '',
      TAMANHO: '',
      NUMERO_SIMCARDS: ''
    }

    setItensArray([...itensArray, newItem])

    setTimeout(() => {
      scrollRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' })
    }, 100)
  }

  return (
    <>
      <div
        className={
          isReposicao
            ? 'input-row-novo-pedido-wrapper-reposicao'
            : 'input-row-novo-pedido-wrapper'
        }
      >
        {itens.map((item, index) => {
          const operadoraSelecionada = item.OPERADORA

          return (
            <div
              className="input-row-novo-pedido"
              key={`${operadoraSelecionada}-${index}`}
            >
              <div className="fonte-cor-1" style={{ flex: 0.1 }}>
                {index + 1}.
              </div>
              <div style={{ flex: 1.5 }} className="input-place">
                <MyAutocomplete
                  temaEscuro={temaEscuro}
                  value={operadoraSelecionada || []}
                  options={operadoraOptions}
                  loading={loading}
                  disableClearable
                  onChange={(event, value) =>
                    handleOperadoraInput(value, index)
                  }
                  renderInputParams={{
                    placeholder: 'Selecione'
                  }}
                />
                {!operadoraSelecionada && <AvisoCampoObrigatorio />}
              </div>
              <div style={{ flex: 1.5 }} className="input-place">
                <MyAutocomplete
                  temaEscuro={temaEscuro}
                  loading={loading}
                  disabled={!operadoraSelecionada}
                  value={item.PLANO || ''}
                  options={planosPorIndex[index] || []}
                  disableClearable
                  onChange={(event, value) => handlePlanoInput(value, index)}
                  renderInputParams={{
                    placeholder: 'Selecione'
                  }}
                />

                {operadoraSelecionada && !item.PLANO && (
                  <AvisoCampoObrigatorio />
                )}
              </div>
              <div style={{ flex: 1.3 }} className="input-place">
                <MyAutocomplete
                  temaEscuro={temaEscuro}
                  disabled={!operadoraSelecionada}
                  value={item.TAMANHO || []}
                  disableClearable
                  options={tipoSIMcardOptions}
                  loading={loading}
                  onChange={(event, value) =>
                    handleTipoSimcardInput(value, item, index)
                  }
                  renderInputParams={{
                    placeholder: 'Selecione'
                  }}
                />
                {operadoraSelecionada && !item.TAMANHO && (
                  <AvisoCampoObrigatorio />
                )}
              </div>
              <div style={{ flex: 1.2 }} className="input-place">
                <MyAutocomplete
                  isQuantidade
                  temaEscuro={temaEscuro}
                  disabled={!operadoraSelecionada}
                  value={item.NUMERO_SIMCARDS || ''}
                  loading={loading}
                  options={[]}
                  noOptionsText="Selecione"
                  freeSolo
                  onInputChange={(event, value) =>
                    handleQuantidadeSimcards(value, item, index)
                  }
                  renderInputParams={{
                    type: 'number',
                    placeholder: 'Selecione'
                  }}
                />
                {operadoraSelecionada && !item.NUMERO_SIMCARDS && (
                  <AvisoCampoObrigatorio />
                )}
              </div>
              {itens.length > 1 && (
                <div style={{ flex: 0.1, marginRight: '16px' }}>
                  <img
                    onClick={() => deleteInputRow(item, index)}
                    className="input-row-delete"
                    height={24}
                    src={lixeiraVermelho()}
                    alt="excluir"
                  />
                </div>
              )}
            </div>
          )
        })}
        <div ref={scrollRef} />
      </div>
      <div className="input-row-novo-pedido-newlote">
        <div className="fonte-cor-1 new-lote-row">{itens.length + 1}.</div>
        {mostrarBotaoNovoLote && (
          <Form.Row>
            <div className="button-novo-lote-wrapper">
              <div
                className={
                  localTema == 'claro'
                    ? 'button-novo-lote'
                    : 'button-novo-lote-dark'
                }
                onClick={() => updateItensArray()}
              >
                <div>NOVO LOTE</div>
              </div>
            </div>
          </Form.Row>
        )}
      </div>
    </>
  )
}

function MyAutocomplete({
  renderInputParams,
  temaEscuro,
  isQuantidade,
  loading,
  ...props
}) {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    function handleScroll(e) {
      const wrapper1 = document.querySelector('.input-row-novo-pedido-wrapper')
      const wrapper2 = document.querySelector(
        '.input-row-novo-pedido-wrapper-reposicao'
      )
      const isDropdown = e.target.closest('.MuiAutocomplete-popper')

      // Se scroll veio do menu do Autocomplete, não faz nada
      if (isDropdown) return

      if (wrapper1?.contains(e.target) || wrapper2?.contains(e.target)) {
        setOpen(false)
      }
    }

    if (open) {
      document.addEventListener('scroll', handleScroll, true)
    }

    return () => {
      document.removeEventListener('scroll', handleScroll, true)
    }
  }, [open])

  return (
    <S.ContainerAutoComplete isQuantidade={isQuantidade}>
      <Autocomplete
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        loading={!isQuantidade && loading}
        loadingText="Carregando..."
        noOptionsText="Sem opções"
        disablePortal
        id={temaEscuro ? 'combo-box-demo-noturno' : 'combo-box-demo'}
        sx={{ width: '100%', height: 40 }}
        {...props}
        renderInput={(params) => (
          <TextField {...params} {...renderInputParams} size="small" />
        )}
      />
    </S.ContainerAutoComplete>
  )
}

export const iconeAlerta = (
  <img className="icone-alerta" src={exclamacao()} alt="exclamacao" />
)

export function AvisoCampoObrigatorio() {
  return <S.Erro>O campo é obrigatorio</S.Erro>
}
